import {TradingRepo} from '../../trading/trading.repo';
import { isNullOrUndefined } from 'util';

class TradePreviewDialogController {

    public tradeItems:Array<any>;
    public tradeSetId:number;
    public portfolio:any;


    /** @ngInject */
    constructor(private $mdDialog: angular.material.IDialogService,private tradingRepo : TradingRepo, private notifyjs) {
        
    }

    $onInit(){
      let  that = this;
      this.tradingRepo.getTradePreview(that.tradeSetId)
      .then((res)=>{
        this.tradeItems = res.data as Array<any>;
      })
    }

    public finaliseTrades() {
      let that = this;
      that.tradingRepo.finaliseTrades(that.tradeSetId).then(
        r => this.$mdDialog.hide(true)
      );
    }
}

  export const tradePreviewDialog: angular.IComponentOptions = {
    template: require('./tradePreview.dialog.html'), 
    controller: TradePreviewDialogController,
    bindings: {
        tradeSetId : "<",
        portfolio : "<"
        
      }

  }


// WEBPACK FOOTER //
// ./src/app/portfolioadmin/tradeRecommendations/tradePreview.dialog.ts